import React from 'react';
import Carousel from '../components/carousel';
import Features from '../components/features';
import Services from '../components/services';
import Footer from '../components/footer';
import Partners from '../components/partners';


const Homepage = () => {
  return (
    <div className="Home">
         
          <Carousel />
          <Features />
          <Services />
          <Partners />
          <Footer />
    </div>
  );
}

export default Homepage;